import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

export const advP4UnderUtilized: FaireAdvertiserProfileEntity = {
  token: "adv_p4_under_utilized",
  type: "advertiserProfile",
  archetype: "big-budget-under-utilized",
  displayName: "Alto Mixer Co.",
  brandToken: "b_adv_p4_under_utilized",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 31,
  budget: {
    totalBudgetDollars: 15000,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-08-01",
    nextBillsAtDate: "2026-08-04",
  },
  overview: {
    numCustomersAcquired: 82,
    numReorderConversions: 74,
    numTotalConversions: 156,
    totalAdsSalesDollars: 96561,
    newCustomerAdsSalesDollars: 59841,
    reorderAdsSalesDollars: 36720,
    totalAdsSpendDollars: 11664,
    newCustomerAdsSpendDollars: 8878,
    reorderAdsSpendDollars: 2786,
    newCustomerBestEstimateFirstYearRoas: 6.74,
    reorderRoas: 13.18,
    combinedFirstYearRoas: 8.28,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 14500,
      maxRecommendedBudgetDollars: 21750,
    },
    reorder: {
      minRecommendedBudgetDollars: 500,
      maxRecommendedBudgetDollars: 750,
    },
  },
  campaignTokens: [
    "camp_p4_under_utilized_new",
    "camp_p4_under_utilized_reorder",
  ],
  overviewPerformancePeriodTokens: [
    "perf_p4_under_utilized_ovw_202510",
    "perf_p4_under_utilized_ovw_202511",
    "perf_p4_under_utilized_ovw_202512",
    "perf_p4_under_utilized_ovw_202601",
    "perf_p4_under_utilized_ovw_202602",
    "perf_p4_under_utilized_ovw_202603",
    "perf_p4_under_utilized_ovw_202604",
    "perf_p4_under_utilized_ovw_202605",
    "perf_p4_under_utilized_ovw_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
